<template>
  <div class="na-menu-item-content">
    <Icon v-if="menuItem.icon && !menuItem.hideIcon"
          :icon="menuItem.icon"
          :pack="menuItem.iconPack || 'fal'"
          fixed-width class="mr-3"
    />
    <div class="na-menu-item-title"
         :class="{ 'justify-content-center': align === 'center' }"
         v-if="!menuItem.hideTitle"
         v-html="menuItem.title"
    />
  </div>
</template>

<script>
export default {
  name: 'MenuItemContent',
  data() {
    return {};
  },
  props: {
    align: {
      type: String,
    },
    menuItem: {
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.na-menu-item-content {
  align-items: center;
  display: flex;
  flex: 1;
  padding: 2.5px 0;
  position: relative;

  .icon {

  }

  .na-menu-item-title {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: space-between;

    &.justify-content-center {
      justify-content: center;
    }
  }
}
</style>
